var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x84\xB6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M30.8,13.4c0,0,0.9,0.9,1,2.6c0.1,1.7-0.1,24.3-0.1,24.3 S32.6,50,30.3,51s-1.9,2.6-10.4-0.6c0,0-1.4-1-1.2-0.1c0.2,0.9,2.7,2.4,4.4,4c1.7,1.5,3.7,3.7,4.1,4.3c0.3,0.6,0.9,2.8,2.3,2.4 s6.1-4.2,6.4-6.9c0.3-2.7,0.9-10.4,0.9-10.4l0.2-21.1c0,0-0.1-7.8-0.6-8.3s-2.4-2.7-2.4-2.7L30.8,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7,
    d: " M29.1,9.1c0,0,5.4,4.9,5.8,8.7s0.7,34.1-0.7,35.7c-5.1,5.8-5.4,3.3-16.1-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M31.7,32.7c0,0-4,0.2-5.6,0.8c-1.6,0.6-8.8,2.1-11.2,3.8 s-1.9,1.5-3.1,0.8c-1.1-0.7-4.2-2.7-3.5-3.8c0.7-1,6-2.4,6.8-2.5c0.8-0.2,6.2-1.5,7.6-1.7c1.4-0.2,15.2-2.3,17-2.5 c1.7-0.3,12.2-1.2,12.8-1.3c0.5-0.1,2.5-0.1,3.3,0.4c0.8,0.5,2.4,2.4,2.5,3c0.1,0.6,0.6,2.6-0.3,2.6c-0.9,0-19.7-0.8-20.7-0.6 S31.7,32.7,31.7,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7,
    d: " M8.3,37.5c0,0,28.5-9.3,52.4-7.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M31.7,22.2c0,0-3.8,0.5-5.2,1.4c-1.4,0.9-1.7,1.2-1.9,0.9 s-2.6-2.2-2.2-3.1c0.5-0.9,8.6-3.5,9.5-3.7c0.9-0.2,4.5-0.6,5.2-0.8s4.3-1.2,5-0.9s2.2,2.1,1.9,3.4c-0.2,1.3-0.7,1.7-3,1.7 S33,21.9,31.7,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7,
    d: "M19.4,25.7c0,0,9.6-7.7,24.8-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M30.6,14.2c0,0-8.8,3.9-9.8,3.6s0.6-1.6,1.4-2.2 c0.8-0.6,10.7-9.1,10.7-9.1s2-2.2,2.7-2.1c0.8,0.1,3,1,3.4,3.1s-1.3,2.7-1.7,3C36.8,10.7,30.6,14.2,30.6,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7,
    d: "M39.1,4.4c0,0-14.7,13-21.9,15.1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.6e54ccff6a2a4cd11c69fe0466a8111f.svg";
export { ForwardRef as ReactComponent };